import api from '../config/api';

// Telefon modeli görsellerini çekme
export const fetchPhoneModelTemplates = async (modelId) => {
  try {
    // Telefon modeli şablonlarını backend üzerinden çek
    const response = await api.get(`/phone-templates/${modelId}`);
    
    if (!response.data) {
      throw new Error('Bu model için şablon bulunamadı');
    }
    
    return {
      templateUrl: response.data.template_url,
      maskUrl: response.data.mask_url
    };
  } catch (error) {
    console.error('Telefon modeli görselleri yüklenirken hata:', error);
    throw error;
  }
};

// Tüm telefon modeli şablonlarını çekme
export const fetchAllPhoneTemplates = async () => {
  try {
    const response = await api.get('/phone-templates');
    return response.data;
  } catch (error) {
    console.error('Tüm telefon şablonları yüklenirken hata:', error);
    throw error;
  }
};

// Yeni telefon modeli şablonu ekleme
export const addPhoneTemplate = async (modelId, templateUrl, maskUrl) => {
  try {
    const response = await api.post('/phone-templates', {
      model_id: modelId,
      template_url: templateUrl,
      mask_url: maskUrl
    });
    return response.data;
  } catch (error) {
    console.error('Telefon şablonu eklenirken hata:', error);
    throw error;
  }
};

// Telefon modeli şablonunu güncelleme
export const updatePhoneTemplate = async (templateId, templateUrl, maskUrl) => {
  try {
    const response = await api.put(`/phone-templates/${templateId}`, {
      template_url: templateUrl,
      mask_url: maskUrl
    });
    return response.data;
  } catch (error) {
    console.error('Telefon şablonu güncellenirken hata:', error);
    throw error;
  }
};

// Telefon modeli şablonunu silme
export const deletePhoneTemplate = async (templateId) => {
  try {
    await api.delete(`/phone-templates/${templateId}`);
    return true;
  } catch (error) {
    console.error('Telefon şablonu silinirken hata:', error);
    throw error;
  }
};

// Görsel yükleme
export const uploadTemplateImage = async (file, modelName, isTemplate = true) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('modelName', modelName);
    formData.append('isTemplate', isTemplate);

    const response = await api.post('/phone-templates/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data.url;
  } catch (error) {
    console.error('Görsel yüklenirken hata:', error);
    throw error;
  }
}; 